<template>
  <div id="Banner"> 
    <a-carousel ref="loop" autoplay>
      <img :src="item.img" class="bannerImg" v-for="(item,index) in bannerImg" :key="index" @click="bannerGame(item)">
    </a-carousel>
    <!-- <div class="btnL" @click="prev()">
      <img :src="banner_btn_l" alt="左按钮">
    </div>
    <div class="btnR" @click="next()">
      <img :src="banner_btn_r" alt="右按钮">
    </div> -->
  </div>
</template>
<script>
import { Carousel } from "ant-design-vue";
export default {
  name: "Banner",
  data() {
    return {
      bannerImg: [
        {
          gameName:"街球艺术 3V3",
          img:require("@/assets/index/index_loop_01.png"), 
        },
        // {
        //   gameName:"欢乐宠物店",
        //   img:require("@/assets/index/index_loop_02.png"), 
        // },
        // {
        //   gameName:"腹黑Q神传",
        //   img:require("@/assets/index/index_loop_03.png"), 
        // },
        // {
        //   gameName:"大家来找碴",
        //   img:require("@/assets/index/index_loop_04.png"), 
        // }
      ],
      ballImg:require("@/assets/ball.png"),
      ballIs:false,
      banner_btn_l:require("@/assets/index/banner_btn_l.png"),
      banner_btn_r:require("@/assets/index/banner_btn_r.png"),
    };
  },
  methods: { 
    // 上一张
    prev(){
      this.$refs.loop.prev()
    },
    // 下一张
    next(){
      this.$refs.loop.next()
    },
    // bannner跳转
    bannerGame(item){
      this.$router.push({path:"/gameDetail",query:{gameName:item.gameName}})
    }
  },
  components: {
    aCarousel: Carousel
  }
};
</script>
<style lang="stylus" scoped>
@import './common.styl';

@media screen and (max-width :1080px){
  #Banner{
    padding:0 !important;
    overflow:hidden;
    .btnL,.btnR{
      display:none !important;
    }
  }
}

#Banner{ 
  position relative   
  .btnL,.btnR{
    width:50px;
    height:66px; 
    position:absolute;
    cursor pointer;
    transition:0.1s linear ;
  }
  .btnL{
    left:-100px;
    top:calc((100% - 40px )/ 2)
  }
  .btnR{
    right:-100px;
    top:calc((100% - 40px )/ 2)
  }
  .btnL:active{
    transform:scale(1.2)
  }
  .btnR:active{
    transform:scale(1.2)
  }
  .slick-dots{
    border:1px solid red !important;
  }
}
.bannerImg {
  width: 100%;
  cursor pointer   
  img { 
    width: 100%;  
  }
}

.btns {
  width: 500px;
  height: 40px; 
  margin:0 auto;
  flex-between();
  align-items:center;
  position relative
  div{ 
    cursor pointer
    width:30px;
    height:30px;
    background:#fff;
    border:4px solid #1890ff;
    border-radius 100%
  }
  .ball{
    width:30px;
    height:30px; 
    transition:2s;
    img{
      width:100%;
      height:100%;
    }
  }
  .ballChange{
    transform: translate(100px,-100px);  
    animation-timing-function: linear cubic-bezier(.17,.67,.47,.95);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Banner.vue